import { loadMessages } from './i18nMessages';
import { RootState, AppDispatch } from './../core/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Locale = 'pt' | 'es' | 'en';

interface UserPreferencesState {
  originalLocale: string;
  locale: Locale;
  widgetUrl: string;
}

const initialState: UserPreferencesState = {
  originalLocale: 'pt-br',
  locale: 'pt',
  widgetUrl: '/',
};

const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    setOriginalLocale: (state: UserPreferencesState, action: PayloadAction<string>) => {
      state.originalLocale = action.payload;
    },
    setLocale: (state: UserPreferencesState, action: PayloadAction<Locale>) => {
      state.locale = action.payload;
    },
    setWidgetUrl: (state: UserPreferencesState, action: PayloadAction<string>) => {
      state.widgetUrl = action.payload;
    },
  },
});

export default userPreferencesSlice.reducer;

export const { setLocale, setWidgetUrl, setOriginalLocale } = userPreferencesSlice.actions;
export const localeSelector = (state: RootState) => state.userPreferences.locale;

export const setupLocale = (text: string) => async (dispatch: AppDispatch) => {
  dispatch(setOriginalLocale(text));

  const locale = defineInitialLocale(text);
  dispatch(changeLocale(locale));
};

export const changeLocale = (locale: Locale) => (dispatch: AppDispatch) => {
  dispatch(setLocale(locale));
  dispatch(loadMessages(locale));
};

const defineInitialLocale = (text: string): Locale => {
  const supportedLocales = ['pt', 'es', 'en'];
  const navigatorLocale = text.split(/-/)[0] || 'pt';
  if (supportedLocales.includes(navigatorLocale)) {
    return navigatorLocale as Locale;
  } else {
    return 'pt';
  }
};

export const widgetUrlSelector = (state: RootState) => state.userPreferences.widgetUrl;
